import { DeleteCampaignModal } from '@/features/campaigns/components/CampaignDetails/CampaignSettings/parts';
import RouteConstants from '@/features/router/RouteConstants';
import { useModalContext } from '@/hooks/useModalContext';
import { EditIcon, IconButton, TrashIcon } from '@/lib';
import { CampaignV2Response } from '@/services/endpoints/campaigns/types';
import React, { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type WhatsappCampaignListActionsCellProps = {
  campaign: CampaignV2Response;
  isWorkspaceAdmin: boolean;
};

export const WhatsappCampaignListActionsCell: FC<WhatsappCampaignListActionsCellProps> = ({ campaign, isWorkspaceAdmin }) => {
  const { t } = useTranslation('campaign');
  const history = useHistory();
  const { openModal } = useModalContext();

  const handleEdit = (event: SyntheticEvent) => {
    event.stopPropagation();
    history.push(RouteConstants.editCampaignWhatsapp.replace(':campaignId', campaign.id));
  };

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    openModal({
      renderContent: DeleteCampaignModal,
      renderContentProps: {
        campaign,
        redirectAfterDelete: RouteConstants.whatsappCampaigns,
      },
      dismissable: true,
      fullWidth: false,
      fullHeight: false,
    });
  };

  return (
    <div className='flex items-center gap-1.5'>
      <IconButton
        type='button'
        intent='link-grey'
        className='!p-1.5 text-quaternary-400'
        leadingIcon={<EditIcon className='size-4' />}
        onClick={handleEdit}
        aria-label={t('editWhatsAppCampaign')}
        title={t('editWhatsAppCampaign')}
      />
      {isWorkspaceAdmin ? (
        <IconButton
          type='button'
          intent='link-grey'
          className='!p-1.5 text-red-600 hover:text-red-800'
          leadingIcon={<TrashIcon className='size-4' />}
          onClick={handleDelete}
          aria-label={t('deleteThisCampaign')}
          title={t('deleteThisCampaign')}
        />
      ) : null}
    </div>
  );
};
